import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { ProjectCustomFieldDefinition } from '../../netgen/ProjectCustomFieldDefinition';

@Component({
    selector: 'app-edit-project-custom-field-definition',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProjectCustomFieldDefinitionComponent extends AdminBaseEditComponent<ProjectCustomFieldDefinition> {

    definition = ProjectPlanningTools.definitionProjectCustomFieldDefinition;

    getForm(): FrontendForm {
        return this.app.tForm("entity.ProjectCustomFieldDefinition.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { mandatory: true }),
            new FrontendField("order", "", FrontendFieldType.int),
            new FrontendField("dropdownField", "", FrontendFieldType.bool, {
                onValueChanged: this.dropdownFieldChanged.bind(this),
                callValueChangedAfterLoad: true
            }),
            new FrontendField("dropdownOptions", "", FrontendFieldType.stringList)               
        ]));
    }

    dropdownFieldChanged(): void {
        this.form.getField("dropdownOptions").visible = this.form.getField("dropdownField").getValueBool();
    }
    
}
